import { render, staticRenderFns } from "./katalog-reisen-view.vue?vue&type=template&id=1d345d8d"
import script from "./katalog-reisen-view.vue?vue&type=script&lang=js"
export * from "./katalog-reisen-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports